import { createSlice } from '@reduxjs/toolkit'

import {
  failureAction,
  requestAction,
  successAction
} from '~/utils/reducerFunctions'

export interface DashboardData {
  new_referrals: number
  scheduled_referrals: number
  completed_referrals: number
  clinics_collection?: number
}

export interface DashboardState {
  data: Partial<DashboardData>
  loading: boolean
  loaded: boolean
  error: any
}

export const initialState: DashboardState = {
  data: {},
  loading: false,
  loaded: false,
  error: null
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    requests: requestAction,

    success: successAction,

    failure: failureAction
  }
})
export const { requests, success, failure } = dashboardSlice.actions

export default dashboardSlice.reducer
